import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useEffect, useMemo, useState } from "react";
import { isValidMotionProp, motion } from "framer-motion";
import { Helmet } from "react-helmet";

import "./styles.css";
import dayjs from "dayjs";
import { getBetRecord } from "../../api/getApi";
import { Link } from "react-router-dom";
import BetRecordDetail from "./BetRecordDetail";
import NotFound from "../ProgressBlock/NotFound";
import useIsLandScapeMachine from "../../hook/useIsLandScapeMachine";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const BetRecordButton = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openBetRecordDetail, setOpenBetRecordDetail] = useState(false);

  const [selectedGame, setSelectedGame] = useState("ALL");
  const [betRecords, setBetRecords] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const handleClick = () => {
    setOpenModal(true);
  };

  const fontStyle = useMemo(() => {
    return {
      className: "empire_font",
      fontSize: {
        base: "40px",
      },
      color: "#FFC6E5",
    };
  }, []);

  const gameOptions =
    Object.keys(betRecords).length > 0
      ? [
          ...Object.keys(betRecords).filter(
            (key) => betRecords[key].totalBet >= 0
          ),
        ]
      : [];

  useEffect(() => {
    const fetchBetRecords = async () => {
      setIsLoading(true);
      try {
        // 計算時間範圍：現在到15分鐘前
        const endTime = dayjs();
        const startTime = endTime.subtract(15, "minute");

        const result = await getBetRecord({
          params: {
            str_date: startTime.toDate(),
            end_date: endTime.toDate(),
          },
        });

        if (result && result.data) {
          setBetRecords(result.data);
        }
      } catch (error) {
        console.error("無法獲取投注記錄:", error);
      } finally {
        setIsLoading(false);
      }
    };
    if (openModal) {
      fetchBetRecords();
    }
  }, [openModal]);

  const isLandScapeMachine = useIsLandScapeMachine();

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.cdnfonts.com/css/a-absolute-empire"
          rel="stylesheet"
        />
      </Helmet>
      <Box
        onClick={handleClick}
        position="relative"
        cursor={"pointer"}
        display="flex"
        alignItems={"center"}
        justifyContent={"center"}
        shadow="sm"
      >
        <Image
          src={`${COMMON_WEB_PATH}/now888/betRecord${
            i18next.language == "tw" ? "" : `/${i18next.language}`
          }/bet_record_button${isLandScapeMachine ? "_circle" : ""}.png`}
          height={
            isLandScapeMachine
              ? { sm: "70px", md: "70px", lg: "70px", xl: "90px" }
              : {
                  xl: "85px",
                }
          }
          w={
            isLandScapeMachine
              ? { sm: "70px", md: "70px", lg: "70px", xl: "90px" }
              : isLandScapeMachine
              ? "110px"
              : "unset"
          }
          //minW="90px"
          minW={
            isLandScapeMachine
              ? { sm: "70px", md: "70px", lg: "70px", xl: "90px" }
              : "110px"
          }
        />
      </Box>
      {openBetRecordDetail && (
        <BetRecordDetail
          fontStyle={fontStyle}
          setOpenBetRecordDetail={setOpenBetRecordDetail}
        />
      )}
      {openModal && (
        <Flex
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bg="rgba(0, 0, 0, 0.8)"
          zIndex="9999"
          //   backdropFilter="blur(2px)"
          justifyContent="center"
          alignItems="center"
        >
          <ChakraBox
            as={Flex}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.3 }}
            w="470px"
            minH="500px"
            bgImage={`url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_background.png')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            position={"relative"}
            p={6}
            pt={"50px"}
            px="50px"
          >
            <Box
              position="absolute"
              bgImage={`url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_close.png')`}
              bgSize="100% 100%"
              bgPos="center"
              w="50px"
              h="50px"
              top="-10px"
              right="-10px"
              cursor="pointer"
              onClick={() => {
                setOpenModal(false);
              }}
            ></Box>
            <AbsoluteCenter top="-15px">
              <Image
                src={`${COMMON_WEB_PATH}/now888/betRecord/bet_record_title.png`}
              />
            </AbsoluteCenter>
            <Box maxH="500px" overflowY="scroll" w="100%">
              {gameOptions?.length == 0 && <NotFound />}
              {gameOptions?.map((platform) => {
                return (
                  <Flex
                    as={Link}
                    to={{
                      search: `?game=${platform}`,
                    }}
                    onClick={() => {
                      setOpenBetRecordDetail(true);
                    }}
                    py="5px"
                    position="relative"
                    w="100%"
                    justifyContent="center"
                    alignItems="center"
                    _hover={{
                      bgImage: `url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_selected.png')`,
                      bgSize: "100% 100%",
                    }}
                    _after={{
                      content: "''",
                      position: "absolute",
                      bottom: "-10px",
                      left: "0",
                      width: "100%",
                      height: "10px",
                      bgImage: `url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_divider.png')`,
                      bgSize: "100%100%",
                      bgPos: "center",
                    }}
                    mb="10px"
                  >
                    <Text {...fontStyle}>{platform}</Text>
                  </Flex>
                );
              })}
            </Box>
          </ChakraBox>{" "}
        </Flex>
      )}
    </>
  );
};

export default BetRecordButton;
